import { render, staticRenderFns } from "./FormResource.vue?vue&type=template&id=263f9737&scoped=true&"
import script from "./FormResource.vue?vue&type=script&lang=js&"
export * from "./FormResource.vue?vue&type=script&lang=js&"
import style0 from "./FormResource.vue?vue&type=style&index=0&id=263f9737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f9737",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCheckbox,VFlex,VIcon,VLayout,VToolbar,VToolbarTitle})
